import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import mutations from "./mutations";
import defaultState from "./defaultState";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: 'Wiagro-store',
    storage: window.localStorage
});

const store = new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: JSON.parse(JSON.stringify(defaultState)),
    mutations: {
        [mutations.SAVE_TOKEN](state, token) {
            state.token = token;
        },
        [mutations.SAVE_USER](state, user) {
            state.user = user;
        },
        [mutations.DELETE_STORE](state) {
            Object.assign(state, defaultState)

        },
        [mutations.UPDATE_TOKEN](state, token) {
            state.token = token;
        },
        [mutations.UPDATE_USER](state, user) {
            state.user = user;
        },
        [mutations.CHANGE_LANGUAGE](state, language) {
            state.language = language;
        },
        [mutations.CHANGE_SILO_SELECTED](state, silo) {
            state.siloSelected = silo;
        },
        [mutations.CHANGE_SITE_SELECTED](state, site) {
            state.siteSelected = site;
        },
        [mutations.ADD_EVENTS](state, events) {
            let eventsToAdd = [];
            if (Array.isArray(events)) {
                eventsToAdd = events;
            } else {
                eventsToAdd.push(events)
            }
            eventsToAdd.forEach(event => {
                const index = state.events.findIndex(e => event.eventid === e.eventid);
                if (index === -1) {
                    state.events.push(event);
                } else {
                    state.events.splice(index, 1, event);
                }
            })

        },
        [mutations.DELETE_EVENT](state, events) {
            if (events === undefined || events.length === 0) {
                return
            }
            let eventsToDelete = [];
            if (Array.isArray(events)) {
                eventsToDelete = events;
            } else {
                eventsToDelete.push(events)
            }

            eventsToDelete.forEach(event => {
                const index = state.events.findIndex(e => event.eventid === e.eventid);
                if (index !== -1) {
                    state.events.splice(index, 1);
                } else {
                    console.error("No borro evento porque no esta en el store");
                }
            })

        },
        [mutations.SAVE_SITES](state, sites) {
            state.sites = sites;
        },
        [mutations.IS_SYNCHRONIZING](state, isSynchronizing) {
            state.isSynchronizing = isSynchronizing
        },
        [mutations.CHANGE_VIEW_DETAILS](state, viewDetails) {
            state.viewDetails = viewDetails;
        }
    },
    getters: {
        unit: (state) => type => {
            if (type === "hum" || type === "moisture") {
                return "%"
            } else if (type === "temp") {
                if (state.user !== undefined && state.user.units !== undefined) {
                    let split = state.user.units.split(",");
                    if (split.length > 0) {
                        return split[0].toUpperCase() === "C" ? "C°" : "F";
                    }
                }
                return "";
            } else if (type === "co2") {
                if (state.user !== undefined && state.user.units !== undefined) {
                    let split = state.user.units.split(",");
                    if (split.length > 0) {
                        return split[1] === "%" ? "%" : "ppm";
                    }
                }
                return ""
            } else {
                throw "Invalid type, Expected to be hum, temp, co2 or moisture"
            }
        }

    }
});

export default store;